// @ts-strict-ignore
import React, { ReactNode, useRef, useState } from 'react';
import styled, { css } from 'styled-components';
import { display } from 'styled-system';

import { colors, transition } from 'theme';

const Tooltip = styled(({ display: displayProp, left, top, ...props }) => (
  // TODO: Fix this the next time the file is edited.
  // eslint-disable-next-line react/jsx-props-no-spreading
  <div {...props} />
)).attrs(({ left, top }) => ({
  style: {
    left,
    top,
  },
}))`
  position: fixed;
  z-index: 9999;
  transform: translate3d(-50%, 3px, 0);
  background: white;
  border: 1px solid ${colors.greyishBrown};
  box-shadow: 0 1px 3px rgba(0, 0, 0, 0.15);
  border-radius: 7px;
  opacity: 0;
  color: ${colors.battleshipGrey};
  visibility: hidden;
  font-size: 12px;
  transition: all ${transition};
  transition-property: opacity, transform, visibility;
  ${display};

  ${(props) =>
    props.$showArrow &&
    css`
      &::after {
        content: '';
        position: absolute;
        z-index: -1;
        bottom: -7px;
        left: 50%;
        transform: translateX(-50%) translateY(-50%) rotate(45deg);
        display: block;
        width: 5px;
        height: 5px;
        background: white;
        border: 1px solid ${colors.greyishBrown};
        box-shadow: 0 1px 3px rgba(0, 0, 0, 0.15);
      }
    `}
`;

const TooltipInner = styled.div`
  background-color: white;
  border-radius: 7px;
  padding: 2px 8px;
  z-index: 1;
`;

const Container = styled.div`
  text-align: left;

  &:hover,
  &:focus,
  &:focus-within {
    ${Tooltip} {
      transform: translate3d(-50%, 0, 0);
      opacity: 1;
      visibility: visible;
    }
  }
`;

type Props = {
  text: ReactNode;
  offsetBottom?: number;
  positionAbove?: boolean;
  showArrow?: boolean;
  disabled?: boolean;
  children: ReactNode;
  xs?: boolean;
  sm?: boolean;
  md?: boolean;
  lg?: boolean;
  xl?: boolean;
};

export function SimpleTooltip({
  text,
  positionAbove,
  showArrow,
  offsetBottom,
  disabled,
  children,
  xs,
  sm,
  md,
  lg,
  xl,
}: Props) {
  const [left, setLeft] = useState(0);
  const [top, setTop] = useState(0);
  const ref = useRef(null);

  const update = () => {
    if (ref && ref.current) {
      const rect = ref.current.getBoundingClientRect();
      if (positionAbove) {
        setTop(rect.top - rect.height + (offsetBottom || 0));
      } else {
        setTop(rect.top + rect.height + (offsetBottom || 0));
      }
      setLeft(rect.left + rect.width / 2);
    }
  };

  return (
    <Container ref={ref} onMouseOver={update} onFocus={update}>
      {children}
      {!disabled && (
        <Tooltip
          display={[xs, sm, md, lg, xl].map((n) => (n ? 'none' : 'block'))}
          $showArrow={showArrow}
          left={left}
          top={top}
        >
          <TooltipInner>{text}</TooltipInner>
        </Tooltip>
      )}
    </Container>
  );
}
